import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { ButtonType } from 'src/components/Shared/Button';
import Button from 'src/components/Shared/Button/Button';
import CheckMark from 'src/components/Shared/CheckMark/CheckMark';
import CollegeBrandingContainer from 'src/components/Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import config from 'src/config/config';
import IRAAutoMaxWhatsNext from 'src/components/Confirmation/WhatsNext/RecurringBuy/IRAAutoMaxWhatsNext';
import './RecurringBuyConfirmation.scss';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';
import { ConfirmationSnapshot } from 'src/components/Confirmation/ConfirmationSnapshot/ConfirmationSnapshot';
import { useHistory } from 'react-router';

export const IRAAutoMaxConfirmation = (props) => {
  const {
    transactions,
    isSalesforceRep,
    customerWebViewEnabled,
    confirmationNumber,
    tradeDate,
    success,
    hasPaperless,
    contributions,
  } = props;

  const history = useHistory();
  const wrapperEl = useRef(null);

  useEffect(() => {
    if (wrapperEl.current) {
      ReactDOM.findDOMNode(wrapperEl.current).scrollIntoView();
    }

    dispatchPageLoad('Confirmation');
  }, []);

  // no contributions?!? to ATLP with you!
  if (!contributions?.length) {
    history.push(`/usis/transactions/automatic${window.location.search}`);
    return <></>;
  }

  return (
    <div ref={wrapperEl}>
      <CollegeBrandingContainer>
        <div className="recurring-buy-confirmation-page">
          <div className="recurring-buy-confirmation-background-design college-branded-header">
            <span className="recurring-buy-confirmation-background-design-inner" />
          </div>
          <div className="recurring-buy-header-wrapper">
            <div className="container">
              <div className="recurring-buy-confirmation-container row">
                <div className="recurring-buy-confirmation-submit-text">
                  <div className="recurring-buy-confirmation-heading">
                    Your automatic transaction has been submitted!{' '}
                  </div>
                  <div className="recurring-buy-confirmation-subheading">
                    You will be {hasPaperless ? ' emailed' : ' mailed'} a
                    confirmation of this transaction.
                  </div>
                </div>
                <div className="recurring-buy-snapshot-wrapper">
                  <ConfirmationSnapshot
                    id="confirmation-snapshot"
                    successIcon={
                      <CheckMark className="recurring-buy-confirmation-checkmark" />
                    }
                    isSalesforceRep={isSalesforceRep}
                    customerWebViewEnabled={customerWebViewEnabled}
                    tradeDate={tradeDate}
                    transactions={transactions}
                    success={success}
                    confirmationNumber={confirmationNumber}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="recurring-buy-confirmation-mobile-buttons">
              <a href={`${config.url}/usis/transactions/automatic`}>
                <Button buttonType={ButtonType.SECONDARY_GHOST}>
                  <div className="button-text">
                    View Your Automatic Transactions
                  </div>
                </Button>
              </a>
              <a href={`${config.url}/usis/my-accounts/dashboard`}>
                <Button buttonType={ButtonType.SECONDARY_GHOST}>
                  Go to Dashboard
                </Button>
              </a>
            </div>
            <IRAAutoMaxWhatsNext />
          </div>
          <p className="container">2820038</p>
        </div>
      </CollegeBrandingContainer>
    </div>
  );
};
